// daterangepicker's UMD resolves moment/jQuery from window in the browser ESM
// bundle. This module sets those globals and MUST be imported before
// 'daterangepicker' so they exist when the plugin evaluates (ESM executes
// imports in source order).
import $ from 'jquery';
import moment from 'moment';

type WindowWithLibs = Window & { $?: typeof $; jQuery?: typeof $; moment?: typeof moment };
const w = window as WindowWithLibs;
w.$ = w.jQuery = $;
w.moment = moment;

export {};
